/* BEGIN TFX_BLOG_ARTICLE_H3_DISCLOSURES
   Objective: transform article-body H3 headings into native theme disclosures within the article content.
   Impacted pages: templates/article.json via sections/tfx-main-article.liquid
   Dependencies: assets/tfx-blog-article.css, assets/main.js, sections/tfx-main-article.liquid
   Date: 2026-04-18
*/
(function () {
  function getArticleSections(root) {
    const scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-tfx-main-article]')) {
      return [scope];
    }

    return Array.from(scope.querySelectorAll('[data-tfx-main-article]'));
  }

  function openAncestorDisclosures(target) {
    if (!target || !(target instanceof Element)) return;

    let current = target.parentElement;

    while (current) {
      if (current.tagName === 'DETAILS') {
        current.open = true;
      }
      current = current.parentElement;
    }
  }

  function getTargetFromHash(articleRoot, hash) {
    if (!articleRoot || !hash) return null;

    const rawId = hash.charAt(0) === '#' ? hash.slice(1) : hash;
    if (!rawId) return null;

    let decodedId = rawId;

    try {
      decodedId = window.decodeURIComponent(rawId);
    } catch (error) {
      decodedId = rawId;
    }

    const target = document.getElementById(decodedId);

    if (!target || !articleRoot.contains(target)) {
      return null;
    }

    return target;
  }

  function transformHeading(heading) {
    const content = heading && heading.parentNode;
    if (!heading || !content) return null;

    const disclosureHost = document.createElement('details-disclosure');
    const disclosure = document.createElement('details');
    const summary = document.createElement('summary');
    const panel = document.createElement('div');
    const disclosureContent = document.createElement('div');

    disclosure.className = 'disclosure tfx-blog-article__h3-disclosure';
    disclosure.setAttribute('data-tfx-article-h3-disclosure', '');
    summary.className = 'disclosure__title';
    panel.className = 'disclosure__panel has-motion';
    disclosureContent.className = 'disclosure__content rte cf';

    content.insertBefore(disclosureHost, heading);
    disclosureHost.appendChild(disclosure);
    disclosure.appendChild(summary);
    summary.appendChild(heading);
    disclosure.appendChild(panel);
    panel.appendChild(disclosureContent);

    let nextNode = disclosureHost.nextSibling;

    while (nextNode) {
      const upcomingNode = nextNode.nextSibling;

      if (
        nextNode.nodeType === Node.ELEMENT_NODE &&
        /^(H2|H3)$/i.test(nextNode.tagName)
      ) {
        break;
      }

      disclosureContent.appendChild(nextNode);
      nextNode = upcomingNode;
    }

    if (typeof disclosureHost.init === 'function') {
      disclosureHost.disclosure = disclosureHost.querySelector('details');
      disclosureHost.toggle = disclosureHost.querySelector('summary');
      disclosureHost.panel = disclosureHost.toggle ? disclosureHost.toggle.nextElementSibling : null;
      disclosureHost.init();
    }

    return disclosureHost.nextSibling;
  }

  function isTransformableHeading(heading, content) {
    if (!heading || !content || !content.contains(heading)) return false;

    return !heading.closest('details, details-disclosure, [data-tfx-article-h3-disclosure]');
  }

  function buildH3Disclosures(section) {
    if (!section) return;

    const articleRoot = section.matches('[data-tfx-main-article]') ? section : section.querySelector('[data-tfx-main-article]');
    if (!articleRoot) return;

    const content = articleRoot.querySelector('.tfx-blog-article__content');
    if (!content || content.dataset.tfxH3DisclosuresReady === 'true') return;

    const headings = Array.from(content.querySelectorAll('h3'));

    headings.forEach(function (heading) {
      if (isTransformableHeading(heading, content)) {
        transformHeading(heading);
      }
    });

    content.dataset.tfxH3DisclosuresReady = 'true';

    const initialTarget = getTargetFromHash(articleRoot, window.location.hash);
    openAncestorDisclosures(initialTarget);
  }

  function init(root) {
    getArticleSections(root).forEach(function (section) {
      buildH3Disclosures(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.addEventListener('hashchange', function () {
    getArticleSections(document).forEach(function (section) {
      const target = getTargetFromHash(section, window.location.hash);
      openAncestorDisclosures(target);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    init(event.target || document);
  });
})();

/* BEGIN TFX_BLOG_ARTICLE_TOC
   Objective: generate a clickable table of contents for the dedicated article section.
   Impacted pages: templates/article.json via sections/tfx-main-article.liquid
   Dependencies: assets/tfx-blog-article.css, sections/tfx-main-article.liquid
   Date: 2026-04-09
   Rollback: remove the script include from sections/tfx-main-article.liquid, then delete this file.
*/

(function () {
  function slugify(text) {
    return (text || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function uniqueId(baseId, usedIds) {
    let id = baseId || 'section-heading';
    let index = 2;

    while (usedIds.has(id) || document.getElementById(id)) {
      id = (baseId || 'section-heading') + '-' + index;
      index += 1;
    }

    usedIds.add(id);
    return id;
  }

  function getTargetFromHash(articleRoot, hash) {
    if (!articleRoot || !hash) return null;

    const rawId = hash.charAt(0) === '#' ? hash.slice(1) : hash;
    if (!rawId) return null;

    let decodedId = rawId;

    try {
      decodedId = window.decodeURIComponent(rawId);
    } catch (error) {
      decodedId = rawId;
    }

    const target = document.getElementById(decodedId);

    if (!target || !articleRoot.contains(target)) {
      return null;
    }

    return target;
  }

  function openAncestorDisclosures(target) {
    if (!target || !(target instanceof Element)) return;

    let current = target.parentElement;

    while (current) {
      if (current.tagName === 'DETAILS') {
        current.open = true;
      }
      current = current.parentElement;
    }
  }

  function ensureHeadingId(heading, usedIds) {
    const existingId = (heading.id || '').trim();

    if (existingId && !usedIds.has(existingId) && document.getElementById(existingId) === heading) {
      usedIds.add(existingId);
      return existingId;
    }

    const fallbackId = slugify(existingId || heading.textContent);
    const nextId = uniqueId(fallbackId, usedIds);

    heading.id = nextId;
    return nextId;
  }

  function setTocToggleState(group, expanded) {
    if (!group) return;

    const toggle = group.querySelector('[data-tfx-toc-toggle]');
    const sublist = group.querySelector('[data-tfx-toc-sublist]');
    if (!toggle || !sublist) return;

    const label = expanded ? 'Masquer les sous-sections' : 'Afficher les sous-sections';
    const hiddenLabel = toggle.querySelector('.visually-hidden');

    group.classList.toggle('is-open', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.setAttribute('aria-label', label);
    sublist.hidden = !expanded;

    if (hiddenLabel) {
      hiddenLabel.textContent = label;
    }
  }

  function revealTocGroupForTarget(tocBlock, target) {
    if (!tocBlock || !target || !target.id) return;

    const groups = tocBlock.querySelectorAll('[data-tfx-toc-group]');
    groups.forEach((group) => {
      const childIds = (group.dataset.tfxTocChildIds || '').split(' ').filter(Boolean);
      if (childIds.indexOf(target.id) !== -1) {
        setTocToggleState(group, true);
      }
    });
  }

  function getAlphaLabel(index) {
    let value = index;
    let label = '';

    while (value > 0) {
      value -= 1;
      label = String.fromCharCode(97 + (value % 26)) + label;
      value = Math.floor(value / 26);
    }

    return label || 'a';
  }

  function createTocMarker(marker, level) {
    const markerElement = document.createElement('span');

    markerElement.className = 'tfx-blog-article__toc-marker tfx-blog-article__toc-marker--' + level;
    markerElement.textContent = marker;

    return markerElement;
  }

  function createTocText(label) {
    const text = document.createElement('span');

    text.className = 'tfx-blog-article__toc-link-text';
    text.textContent = label;

    return text;
  }

  function createTocLink(headingId, label, level) {
    const link = document.createElement('a');

    link.className = 'tfx-blog-article__toc-link tfx-blog-article__toc-link--' + level;
    link.href = '#' + window.encodeURIComponent(headingId);
    link.appendChild(createTocText(label));
    return link;
  }

  function buildToc(section) {
    if (!section) return;

    const articleRoot = section.matches('[data-tfx-main-article]') ? section : section.querySelector('[data-tfx-main-article]');
    if (!articleRoot) return;

    const content = articleRoot.querySelector('.tfx-blog-article__content');
    if (!content) return;

    const tocBlocks = articleRoot.querySelectorAll('[data-tfx-article-toc]');
    if (!tocBlocks.length) return;

    tocBlocks.forEach((tocBlock) => {
      if (!tocBlock.dataset.tfxTocBound) {
        tocBlock.addEventListener('click', function (event) {
          const toggle = event.target.closest('[data-tfx-toc-toggle]');
          if (toggle) {
            const group = toggle.closest('[data-tfx-toc-group]');
            if (!group) return;

            event.preventDefault();
            setTocToggleState(group, toggle.getAttribute('aria-expanded') !== 'true');
            return;
          }

          const link = event.target.closest('.tfx-blog-article__toc-link');
          if (!link) return;

          const hash = link.getAttribute('href');
          if (!hash || hash.charAt(0) !== '#') return;

          const target = getTargetFromHash(articleRoot, hash);
          if (!target) return;

          openAncestorDisclosures(target);
          revealTocGroupForTarget(tocBlock, target);

          articleRoot
            .querySelectorAll('.is-tfx-toc-targeted')
            .forEach((heading) => heading.classList.remove('is-tfx-toc-targeted'));

          target.classList.add('is-tfx-toc-targeted');

          if (target.__tfxTocTimer) {
            window.clearTimeout(target.__tfxTocTimer);
          }

          target.__tfxTocTimer = window.setTimeout(function () {
            target.classList.remove('is-tfx-toc-targeted');
            target.__tfxTocTimer = null;
          }, 5000);
        });

        tocBlock.dataset.tfxTocBound = 'true';
      }

      const list = tocBlock.querySelector('[data-tfx-toc-list]');
      if (!list) return;

      const selectors = tocBlock.getAttribute('data-tfx-toc-selectors') || 'h2,h3';
      const headings = Array.from(content.querySelectorAll(selectors)).filter((heading) => {
        return heading.textContent && heading.textContent.trim().length > 0;
      });

      list.innerHTML = '';

      if (!headings.length) {
        tocBlock.hidden = true;
        return;
      }

      tocBlock.hidden = false;

      const usedIds = new Set();
      let h2Index = 0;
      let currentGroup = null;

      headings.forEach((heading) => {
        const level = heading.tagName.toLowerCase();
        const headingId = ensureHeadingId(heading, usedIds);

        if (level === 'h3' && currentGroup) {
          if (!currentGroup.sublist) {
            const toggle = document.createElement('button');
            const toggleLabel = document.createElement('span');
            const sublist = document.createElement('ol');

            toggle.type = 'button';
            toggle.className = 'tfx-blog-article__toc-toggle';
            toggle.setAttribute('data-tfx-toc-toggle', '');

            toggleLabel.className = 'visually-hidden';
            toggle.appendChild(toggleLabel);

            sublist.className = 'tfx-blog-article__toc-sublist';
            sublist.id = uniqueId('tfx-article-toc-sublist-' + headingId, usedIds);
            sublist.setAttribute('data-tfx-toc-sublist', '');

            currentGroup.item.classList.add('tfx-blog-article__toc-item--has-children');
            currentGroup.item.setAttribute('data-tfx-toc-group', '');
            currentGroup.entry.appendChild(toggle);
            currentGroup.item.appendChild(sublist);
            currentGroup.sublist = sublist;
            currentGroup.childIds = [];

            toggle.setAttribute('aria-controls', sublist.id);
            setTocToggleState(currentGroup.item, false);
          }

          const subitem = document.createElement('li');
          const link = createTocLink(headingId, heading.textContent.trim(), 'h3');

          subitem.className = 'tfx-blog-article__toc-subitem';
          currentGroup.childCount += 1;
          link.insertBefore(createTocMarker(getAlphaLabel(currentGroup.childCount) + '.', 'h3'), link.firstChild);
          subitem.appendChild(link);

          currentGroup.sublist.appendChild(subitem);
          currentGroup.childIds.push(headingId);
          currentGroup.item.dataset.tfxTocChildIds = currentGroup.childIds.join(' ');
          return;
        }

        if (level === 'h3') {
          return;
        }

        const item = document.createElement('li');
        const entry = document.createElement('div');
        const marker = String(h2Index + 1).padStart(2, '0') + '.';
        const link = createTocLink(headingId, heading.textContent.trim(), 'h2');

        item.className = 'tfx-blog-article__toc-item tfx-blog-article__toc-item--h2';
        entry.className = 'tfx-blog-article__toc-entry';
        entry.appendChild(createTocMarker(marker, 'h2'));
        entry.appendChild(link);
        item.appendChild(entry);
        list.appendChild(item);
        h2Index += 1;
        currentGroup = { item: item, entry: entry, sublist: null, childIds: [], childCount: 0 };
      });

      const initialTarget = getTargetFromHash(articleRoot, window.location.hash);

      openAncestorDisclosures(initialTarget);
      revealTocGroupForTarget(tocBlock, initialTarget);
    });
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const sections = scope.querySelectorAll('[data-tfx-main-article]');

    sections.forEach((section) => buildToc(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    init(event.target || document);
  });
})();

/* BEGIN TFX_BLOG_ARTICLE_TRUST_CARDS
   Objective: keep article trust cards expanded on desktop and collapsible on mobile.
   Impacted pages: templates/article.json via sections/tfx-main-article.liquid
   Dependencies: assets/tfx-blog-article.css, sections/tfx-main-article.liquid
   Date: 2026-04-17
*/
(function () {
  const mobileQuery = window.matchMedia('(max-width: 767.98px)');
  const relatedProductsCarouselQuery = window.matchMedia('(max-width: 1279.98px)');

  function getArticleSections(root) {
    const scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-tfx-main-article]')) {
      return [scope];
    }

    return Array.from(scope.querySelectorAll('[data-tfx-main-article]'));
  }

  function bindTrustCard(card, section) {
    if (!card || card.dataset.tfxTrustBound === 'true') return;

    const summary = card.querySelector('.tfx-blog-article__trust-card-summary');
    if (!summary) return;

    summary.addEventListener('click', function (event) {
      if (!mobileQuery.matches) {
        event.preventDefault();
      }
    });

    card.addEventListener('toggle', function () {
      if (!mobileQuery.matches) {
        if (!card.open) {
          card.open = true;
        }
        return;
      }

      if (!card.open) return;

      section.querySelectorAll('[data-tfx-article-trust-card][open]').forEach(function (otherCard) {
        if (otherCard !== card) {
          otherCard.open = false;
        }
      });
    });

    card.dataset.tfxTrustBound = 'true';
  }

  function syncTrustCards(section, forceReset) {
    if (!section) return;

    const cards = section.querySelectorAll('[data-tfx-article-trust-card]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      bindTrustCard(card, section);

      if (mobileQuery.matches) {
        if (forceReset || card.dataset.tfxTrustMobileReady !== 'true') {
          card.open = false;
        }
        card.dataset.tfxTrustMobileReady = 'true';
        return;
      }

      card.open = true;
      card.dataset.tfxTrustMobileReady = 'false';
    });
  }

  function reinitFeaturedCollectionSideNav(sectionId) {
    if (!sectionId || typeof window.tfxReinitFeaturedCollectionInteractive !== 'function') return;

    window.tfxReinitFeaturedCollectionInteractive(sectionId);
  }

  function getSlideSpan(slides) {
    if (!slides || slides.length < 2) return 0;

    return Math.abs(slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left);
  }

  function bindRelatedProductsSideNav(relatedSection) {
    if (!relatedSection || relatedSection.dataset.tfxBlogRelatedSideNavBound === 'true') return;

    relatedSection.addEventListener('click', function (event) {
      const button = event.target.closest('[data-tfx-fc-side-nav] .slider-nav__btn');
      if (!button || !relatedSection.contains(button) || button.disabled) return;

      const track = relatedSection.querySelector('.tfx-blog-article__related-products-track.slider');
      const slides = Array.from(relatedSection.querySelectorAll('.slider__item:not([hidden])'));
      if (!track || slides.length < 2) return;

      const carousel = track.closest('carousel-slider');
      const slideSpan = carousel && carousel.slideSpan ? carousel.slideSpan : getSlideSpan(slides);
      if (!slideSpan) return;

      const rtl = document.dir === 'rtl';
      const isForward = (button.name === 'next' && !rtl) || (button.name === 'prev' && rtl);
      const scrollBy = slideSpan * (carousel && carousel.slidesToScroll ? carousel.slidesToScroll : 1);

      event.preventDefault();
      event.stopPropagation();

      track.scrollTo({
        left: track.scrollLeft + (isForward ? scrollBy : -scrollBy),
        behavior: 'smooth'
      });
    });

    relatedSection.dataset.tfxBlogRelatedSideNavBound = 'true';
  }

  function syncRelatedProductsCarousel(section) {
    if (!section) return;

    const relatedSection = section.querySelector('[data-tfx-blog-related-products]');
    if (!relatedSection) return;

    bindRelatedProductsSideNav(relatedSection);

    const track = relatedSection.querySelector('.tfx-blog-article__related-products-track.slider');
    if (!track) return;

    const heading = relatedSection.querySelector('[data-tfx-blog-related-products-heading]');
    const shell = relatedSection.querySelector('[data-tfx-blog-related-products-shell]') || track;
    const sectionId = relatedSection.getAttribute('data-section-id');
    const slideCount = track.querySelectorAll('.slider__item:not([hidden])').length;
    const existingCarousel = track.closest('carousel-slider');

    if (!relatedProductsCarouselQuery.matches || slideCount < 2) {
      if (existingCarousel) {
        if (heading) {
          existingCarousel.parentNode.insertBefore(heading, existingCarousel);
        }
        existingCarousel.parentNode.insertBefore(shell, existingCarousel);
        existingCarousel.remove();
      }
      reinitFeaturedCollectionSideNav(sectionId);
      return;
    }

    let carousel = existingCarousel;

    if (!carousel) {
      carousel = document.createElement('carousel-slider');
      carousel.className = 'carousel block collection-slider tfx-blog-article__related-products-carousel';
      relatedSection.insertBefore(carousel, heading || shell);
      if (heading) {
        carousel.appendChild(heading);
      }
      carousel.appendChild(shell);
    } else if (heading && heading.nextElementSibling !== shell) {
      carousel.insertBefore(heading, shell);
    }

    if (typeof carousel.refresh === 'function') {
      carousel.refresh();
    }

    reinitFeaturedCollectionSideNav(sectionId);
  }

  function init(root, forceReset) {
    getArticleSections(root).forEach(function (section) {
      syncTrustCards(section, forceReset);
      syncRelatedProductsCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document, true);
    });
  } else {
    init(document, true);
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', function () {
      init(document, true);
    });
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(function () {
      init(document, true);
    });
  }

  if (typeof relatedProductsCarouselQuery.addEventListener === 'function') {
    relatedProductsCarouselQuery.addEventListener('change', function () {
      init(document, true);
    });
  } else if (typeof relatedProductsCarouselQuery.addListener === 'function') {
    relatedProductsCarouselQuery.addListener(function () {
      init(document, true);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target, true);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target, true);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    init(event.target || document, true);
  });
})();
/* END TFX_BLOG_ARTICLE_TRUST_CARDS */
